<template>
  <scroll-view class="information-index" :scroll="true" v-if="userInfo != null">
    <div class="information-item">
      <div>头像(80*80为最佳)</div>
      <div>
        <van-uploader :after-read="afterRead"><img :src=" file == null? userInfo.cover_image_text : file.ali_url" class="information-item-img" /></van-uploader><span
          class="iconfont icon-046" style="color: #999;"></span>
      </div>
    </div>
    <div class="information-item" @click="moreTap('/contactCatalog/progeny/changePassword')">
      <div>密码</div>
      <div><span class="iconfont icon-046" style="color: #999;"></span></div>
    </div>

    <div class="information-item" style="background-color: #F4F4F4;">
      <div style="font-size: 1.2rem;margin-top: 3rem;color: #999;">个人信息</div>
    </div>

    <div class="information-item">
      <div style="width: 8rem;">手机号码</div>
      <input class="information-item-text" v-model="userInfo.mobile" />
    </div>
    <div class="information-item">
      <div style="width: 8rem;">微信号</div>
      <input class="information-item-text" v-model="userInfo.weixin" />
    </div>
    <div class="information-item">
      <div style="width: 8rem;">电子邮箱</div>
      <input class="information-item-text" v-model="userInfo.email" placeholder="尚未设置电子邮箱" />
    </div>
    <div class="information-item">
      <div style="width: 8rem;">座机</div>
      <input class="information-item-text" v-model="userInfo.telephone" placeholder="尚未设置座机" />
    </div>
    <div class="information-item">
      <div style="width: 8rem;">地址</div>
      <input class="information-item-text" v-model="userInfo.address" />
    </div>

    <div class="information-button" @click="goBack()">保存</div>

  </scroll-view>
</template>

<script>
  import {
    Albumsave,
    Adminalbumpicupload,
    Albumlevelgetinfo,
    Albumgetinfo
  } from '@/request/api.js'
  import {
    Uploader
  } from 'vant';
  export default {
    components: {
      [Uploader.name]: Uploader
    },
    data() {
      return {
        userInfo: null,
        file:null
      }
    },
    created() {
      this.userInfo = this.$store.state.userInfo;
      typeof WeixinJSBridge != 'undefined' && WeixinJSBridge.call('hideOptionMenu');
    },
    methods: {
      moreTap(url) {
        this.$router.push({
          path: url
        })
      },
      async afterRead(event) {
        // 此时可以自行将文件上传至服务器
        let param = new FormData();
        param.append('file',event.file,event.file.name);
        let res = await Adminalbumpicupload(param);
        this.file = res.code;
      },
      async goBack() {
        let param = {
          email:this.userInfo.email,
          weixin:this.userInfo.weixin,
          mobile:this.userInfo.mobile,
          telephone:this.userInfo.telephone,
          address:this.userInfo.address
        }
        this.file == null ? '' : param['cover_image'] = this.file.url;
        let saveinfo = await Albumsave(param);
        
        let res = await Albumlevelgetinfo('');
        let newRes = await Albumgetinfo('');
        newRes = newRes.data;
        newRes['used_space'] = res.data.used_space;
        newRes['pic_space'] = res.data.pic_space;
        this.$api.commit('userInfo',newRes);
        
        history.go(-1);
      }
    }
  }
</script>

<style lang="less">
  .information-index {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #F4F4F4;
    padding-top: 3rem;

    .information-item {
      width: 94%;
      padding: 3%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1.5rem;
      background-color: #FFFFFF;
      border-bottom: 1px solid #F4F4F4;
    }

    .information-item-img {
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 50%;
      margin-right: 0.5rem;
    }

    .information-item>div {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
    }

    .information-item-text {
      flex: 1;
      color: #999;
    }

    .information-button {
      width: 90%;
      background-color: #2590c8;
      color: #FFFFFF;
      padding: 1rem 2%;
      border-radius: 0.5rem;
      text-align: center;
      margin-left: 3%;
      font-size: 1.2rem;
      margin-top: auto;
      margin-top: 3rem;
    }

    input::-webkit-input-placeholder {
      color: #999;
    }

  }
</style>
